// ==========================================================================
// NUYED — Mock data (replaces PHP-rendered dynamic content for the React MVP)
// Data is illustrative and stored client-side. Later replaced by real APIs.
// ==========================================================================

export const avatar = (seed) =>
  `https://api.dicebear.com/9.x/bottts-neutral/svg?seed=${encodeURIComponent(seed)}`;

export const thumb = (title, color = '00E5FF') =>
  `https://placehold.co/600x375/0A0F1C/${color}?text=${encodeURIComponent(title)}`;

export const stats = { users: 0, listings: 0, resources: 0, threads: 0, posts: 0, today: 0 };

// ---- Marketplace / Forum / Resource categories ----
export const marketCats = [
  { slug: 'accounts', name: 'Accounts', color: '#00E5FF', icon: 'user-round', live_count: 842 },
  { slug: 'gaming', name: 'Gaming', color: '#6D28FF', icon: 'gamepad-2', live_count: 531 },
  { slug: 'streaming', name: 'Streaming', color: '#FF3D71', icon: 'tv', live_count: 388 },
  { slug: 'software', name: 'Software', color: '#19E58C', icon: 'app-window', live_count: 412 },
  { slug: 'social-media', name: 'Social Media', color: '#2388FF', icon: 'share-2', live_count: 297 },
  { slug: 'giftcards', name: 'Gift Cards', color: '#FFC23B', icon: 'gift', live_count: 176 },
  { slug: 'vpn-proxies', name: 'VPN & Proxies', color: '#A855F7', icon: 'shield', live_count: 143 },
  { slug: 'crypto', name: 'Crypto', color: '#F7931A', icon: 'bitcoin', live_count: 128 },
  { slug: 'ecommerce', name: 'E-Commerce', color: '#00C2A8', icon: 'shopping-bag', live_count: 96 },
  { slug: 'design', name: 'Design Assets', color: '#EC4899', icon: 'palette', live_count: 214 },
  { slug: 'hosting', name: 'Hosting', color: '#38BDF8', icon: 'server', live_count: 84 },
  { slug: 'services', name: 'Services', color: '#FB923C', icon: 'wrench', live_count: 152 },
];

export const forumCategories = [
  { id: 1, slug: 'announcements', name: 'Announcements', color: '#00E5FF', icon: 'megaphone', threads_count: 42 },
  { id: 2, slug: 'introductions', name: 'Introductions', color: '#19E58C', icon: 'hand', threads_count: 318 },
  { id: 3, slug: 'general-discussion', name: 'General Discussion', color: '#2388FF', icon: 'messages-square', threads_count: 2841 },
  { id: 4, slug: 'marketplace-talk', name: 'Marketplace Talk', color: '#FFC23B', icon: 'shopping-bag', threads_count: 964 },
  { id: 5, slug: 'accounts', name: 'Accounts', color: '#A855F7', icon: 'user-round', threads_count: 1523 },
  { id: 6, slug: 'leaks', name: 'Leaks', color: '#FF3D71', icon: 'database', threads_count: 2109 },
  { id: 7, slug: 'cracking', name: 'Cracking', color: '#F97316', icon: 'terminal', threads_count: 1284 },
  { id: 8, slug: 'coding', name: 'Coding', color: '#38BDF8', icon: 'code-xml', threads_count: 876 },
  { id: 9, slug: 'design', name: 'Design', color: '#EC4899', icon: 'palette', threads_count: 421 },
  { id: 10, slug: 'money', name: 'Making Money', color: '#19E58C', icon: 'banknote', threads_count: 1187 },
  { id: 11, slug: 'ai-automation', name: 'AI & Automation', color: '#6D28FF', icon: 'bot', threads_count: 512 },
  { id: 12, slug: 'off-topic', name: 'Off-Topic', color: '#94A3B8', icon: 'coffee', threads_count: 738 },
];

const usernames = ['ph4ntom', 'nullByte', 'cyb3rWolf', 'gh0stRider', 'darkMatter', 'zeroCool', 'neonViper', 'proxyKing', 'shadowFox', 'binaryBeast', 'voidWalker', 'crypt0nite', 'glitchGod', 'stealthOwl', 'ram_leech'];

export const topUsers = [];

export const recentThreads = [];

export const popularThreads = [];

export const latestResources = [];

export const latestListings = [];

// ---- Blog ----
export const blogCats = [
  { slug: 'news', name: 'News' },
  { slug: 'guides', name: 'Guides' },
  { slug: 'releases', name: 'Releases' },
  { slug: 'security', name: 'Security' },
  { slug: 'community', name: 'Community' },
];

export const blogPosts = [];

// ---- Wallet ----
export const walletData = {
  balance: 12840,
  rateBuy: 0.012,
  rateRedeem: 0.01,
  rateWithdraw: 0.008,
  withdrawMin: 5000,
  weekly: 1240,
  monthly: 4820,
  totalEarned: 89420,
  spent: 76580,
  chart: Object.fromEntries(
    Array.from({ length: 30 }).map((_, i) => {
      const d = new Date(Date.now() - (29 - i) * 86400 * 1000);
      return [d.toISOString().slice(0, 10), Math.round(Math.sin(i / 3) * 400 + 500 + Math.random() * 200)];
    })
  ),
  transactions: Array.from({ length: 8 }).map((_, i) => ({
    id: i + 1,
    type: ['sale', 'purchase', 'reward', 'withdraw', 'topup', 'tip'][i % 6],
    note: ['Sale: Netflix 4K', 'Bought resource pack', 'Daily activity reward', 'Withdrawal to PayPal', 'Top-up via card', 'Tip received'][i % 6],
    amount: [420, -180, 50, -5000, 3000, 120][i % 6],
    balance_after: 12840 - i * 240,
    created_at: Date.now() - i * 3600 * 1000 * 5,
  })),
  orders: [
    { id: 1, amount_usd: 12.0, status: 'paid', provider: 'PayPal', gax_credit: 1000, created_at: Date.now() - 86400000 * 2 },
    { id: 2, amount_usd: 60.0, status: 'paid', provider: 'Crypto', gax_credit: 5000, created_at: Date.now() - 86400000 * 9 },
  ],
  withdrawals: [
    { id: 1, gax_amount: 5000, usd_amount: 40.0, status: 'paid', method: 'PayPal', created_at: Date.now() - 86400000 * 3 },
    { id: 2, gax_amount: 8000, usd_amount: 64.0, status: 'pending', method: 'Crypto', created_at: Date.now() - 86400000 * 1 },
  ],
};

// ---- NUY packs ----
export const gaxPacks = {
  starter: { gax: 1000, price: 4.99 },
  plus: { gax: 5000, price: 19.99 },
  pro: { gax: 12000, price: 39.99 },
  whale: { gax: 30000, price: 89.99 },
};

// ---- Plus ----
export const plusConfig = { monthly: 4.99, yearly: 39.99, bonus: 500 };

// ---- Streaming ----
export const streams = [];

// ---- Feed posts ----
export const feedPosts = [];

// ---- Messages ----
export const conversations = [];

// ---- Affiliate ----
export const affiliateData = {
  code: 'NULLED-PH4NTOM',
  clicks: 1284,
  signups: 142,
  earnings: 8420,
  rate: 15,
  referrals: usernames.slice(0, 5).map((u, i) => ({
    username: u,
    avatar_url: avatar(u),
    joined: Date.now() - (i + 1) * 86400 * 1000 * 4,
    earned: [1200, 840, 320, 640, 210][i],
  })),
};

// ---- Profile (public) ----
export const demoProfile = {
  username: 'ph4ntom',
  avatar_url: avatar('ph4ntom'),
  banner: 'https://picsum.photos/seed/nuyed-banner/1600/400',
  bio: 'Top-rated seller of premium accounts & digital goods. Escrow only. Fast delivery, full warranty.',
  plus: true,
  role: 'Verified Seller',
  tier: 'diamond',
  gax_balance: 250000,
  posts_count: 4820,
  joined: 'Mar 2021',
  rating: 4.9,
  sales: 1284,
  badges: ['Verified', 'Top Seller', 'Early Adopter', 'Plus Member'],
};

// ---- Auth providers (configured from admin) ----
export const authProviders = [
  { key: 'google', label: 'Google', btnCls: 'bg-white hover:bg-gray-100', textCls: 'text-[#1f1f1f]' },
  { key: 'discord', label: 'Discord', btnCls: 'bg-[#5865F2] hover:bg-[#4752c4]', textCls: 'text-white' },
  { key: 'twitter', label: 'X', btnCls: 'bg-black hover:bg-zinc-900 border border-white/20', textCls: 'text-white' },
  { key: 'telegram', label: 'Telegram', btnCls: 'bg-[#229ED9] hover:bg-[#1c8dc4]', textCls: 'text-white' },
];
